import { useContext } from 'react';
import { ViewModeContext, ViewMode } from './viewModeContextDef';

export const useViewMode = (): ViewMode => {
  const context = useContext(ViewModeContext);
  return context.mode;
};
